'use strict';

/**
 * This filter takes an array and shuffles it. This will return a consistent result for a given array until the page is shuffled.
 *
 * Since this caches previous items, it is best to use this *before* other filters, or the cache might get large.
 */
(function () {
  'use strict';

  angular.module('msUtility').filter('shuffle', shuffle);

  function shuffle() {
    // Old browsers don't have Map, so we just wont shuffle for them
    if (typeof Map === 'undefined') {
      return function (list) {
        return list;
      };
    }
    // we need to keep track of things we've already shuffled, so they stay the same until page refresh
    var alreadyShuffled = new Map();

    function shuffleFilter(list) {
      if (alreadyShuffled.has(list)) {
        return alreadyShuffled.get(list);
      }
      var res = _.shuffle(list);
      alreadyShuffled.set(list, res);
      return res;
    }
    return shuffleFilter;
  }
})();